module.exports = __webpack_public_path__ + "img/truecaller.4e58042c.png";